/**
 * Visible overrun chip for closed actual vs planned hours (#2707 / #2655).
 * Open timers and missing/zero planned hours never raise it.
 */

import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { closedActualHours, hasClosedDurationOverrun } from '@/utils/actualTime';
import { formatDuration } from '@/utils/duration';

export interface WorkOrderOverrunBadgeProps {
  plannedHours: number | null | undefined;
  actualDurationHours?: number | null;
}

export function WorkOrderOverrunBadge({
  plannedHours,
  actualDurationHours,
}: WorkOrderOverrunBadgeProps) {
  const { t } = useTranslation('workorders');
  if (!hasClosedDurationOverrun(plannedHours, actualDurationHours)) return null;

  const planned = Number(plannedHours);
  const actual = closedActualHours({ actualDurationHours });
  const actualLabel = formatDuration(actual);
  const plannedLabel = formatDuration(planned);

  return (
    <Chip
      size="small"
      color="warning"
      data-testid="duration-overrun-badge"
      label={t('detail.overrunBadge', { actual: actualLabel, planned: plannedLabel })}
      aria-label={t('detail.overrunAria', { actual: actualLabel, planned: plannedLabel })}
    />
  );
}
